module.exports = __webpack_public_path__ + "static/img/afc4ae365e3c5d48de87b5eab814359.d401f416.png";